import { IconButton, Tooltip } from '@material-ui/core'
import React, { useRef } from 'react'

const CustomTooltip = ({
    index,
    title,
    open,
    handleTooltipOpen,
    handleToolTipClose,
    handleToolIconClick,
}) => {
    const iconRef = useRef(null)
    return (
        <Tooltip
            title={title}
            open={open}
            onClose={handleToolTipClose}
            placement="top-start"
            disableFocusListener
            disableHoverListener={open}
            disableTouchListener
            arrow
        >
            <IconButton
                ref={iconRef}
                onMouseEnter={() => handleTooltipOpen(index)}
                className="buyNTool"
                onMouseLeave={() => handleToolTipClose(index)}
                onClick={(event) => handleToolIconClick(event, index)}
            >
                <img className="infoIcon" src="/assets/svg/infoIcon.svg" />
            </IconButton>
        </Tooltip>
    )
}

export default CustomTooltip
